// ----------------------------------------------------------------------

export function paramCase(str: string): string {
  return str
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

// ----------------------------------------------------------------------

export function snakeCase(str: string): string {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

// ----------------------------------------------------------------------

export function sentenceCase(str: string): string {
  return (str?.charAt(0)?.toUpperCase() ?? '') + (str?.slice(1) ?? '');
}

export function capitalize(str: string): string {
  return (str?.charAt(0)?.toUpperCase() ?? '') + (str?.slice(1)?.toLowerCase() ?? '');
}

// ----------------------------------------------------------------------

export function formatCamelCaseToSentence(str: string): string {
  return str
    .replace(/([A-Z])/g, ' $1') // Add space before capital letters
    .toLowerCase() // Convert all letters to lowercase
    .replace(/^./, (s) => s.toUpperCase()) // Capitalize first letter
    .trim(); // Remove leading space if any
}
